import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SharedModule } from '../../common/shared/shared.module';
import { DashboardModule as DashboardCommon } from '../../common/dashboard/dashboard.module';


@NgModule({
    declarations: [
        DashboardComponent
    ],
    imports: [
        CommonModule,
        DashboardRoutingModule,
        SharedModule,
        DashboardCommon
    ]
})
export class DashboardModule {
}
